import styled from 'styled-components'

export const ActionButton = styled.button`
    background: none;
    border: 0;
    cursor: pointer;
    padding: 0;
    color: ${({ theme }) => theme.colors.primary_500};
    font-size: 16px;
    font-weight: ${({ theme }) => theme.textVariants.body16Strong.fontWeight};
    font-family: ${({ theme }) => theme.textVariants.body16Strong.fontFamily};
`
